import { GA4_MEASUREMENT_ID } from './config';

let loadScheduled = false;
let scriptReady = false;
const queue = [];

function canTrack() {
    return scriptReady && typeof window !== 'undefined' && typeof window.gtag === 'function';
}

function flushQueue() {
    if (!canTrack()) {
        return;
    }

    while (queue.length > 0) {
        const item = queue.shift();
        if (item.type === 'event') {
            window.gtag('event', item.eventName, item.params);
        } else if (item.type === 'page_view') {
            window.gtag('event', 'page_view', item.params);
        }
    }
}

function loadAnalyticsScript() {
    if (loadScheduled || scriptReady || !GA4_MEASUREMENT_ID || typeof window === 'undefined') {
        return;
    }

    loadScheduled = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
    script.onload = () => {
        window.gtag('config', GA4_MEASUREMENT_ID, {
            send_page_view: false,
        });
        scriptReady = true;
        flushQueue();
    };
    document.head.appendChild(script);
}

function scheduleAnalyticsLoad() {
    if (loadScheduled || scriptReady || !GA4_MEASUREMENT_ID || typeof window === 'undefined') {
        return;
    }

    const start = () => loadAnalyticsScript();

    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(start, { timeout: 4000 });
    } else {
        window.setTimeout(start, 2000);
    }
}

export function initAnalytics() {
    scheduleAnalyticsLoad();
    return true;
}

export function trackEvent(eventName, params = {}) {
    if (!GA4_MEASUREMENT_ID || typeof window === 'undefined') {
        return;
    }

    if (canTrack()) {
        window.gtag('event', eventName, params);
        return;
    }

    queue.push({ type: 'event', eventName, params });
    scheduleAnalyticsLoad();
}

export function trackPageView(pagePath) {
    if (!GA4_MEASUREMENT_ID || typeof window === 'undefined') {
        return;
    }

    const params = {
        page_path: pagePath,
        page_location: `${window.location.origin}${pagePath}`,
    };

    if (canTrack()) {
        window.gtag('event', 'page_view', params);
        return;
    }

    queue.push({ type: 'page_view', params });
    scheduleAnalyticsLoad();
}

export function trackTabViewed(tab, entry = 'click') {
    trackEvent('tab_viewed', { tab, entry });
    trackPageView(`/${tab}`);
}

export { GA4_MEASUREMENT_ID };
